import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

import * as ActionTypes from "../../actions/actionTypes";
import * as ExperiencesActions from "../../actions/experiencesActions";
import * as constants from "../../constants";

const createExperienceLogic = createLogic({
	type: ActionTypes.CREATE_EXPERIENCE,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					headers: { Authorization: "Bearer " + token },
				});
				api.post(
					"/experiences",
					Object.assign(
						{},
						{
							name: action.name,
							key: action.key,
							culture: action.culture,
							appId: action.appKey,
						}
					)
				)
					.then(data => {
						dispatch(ExperiencesActions.createExperienceSuccess(data.data));
						done();
					})
					.catch(error => {
						dispatch(ExperiencesActions.createExperienceFail(error));
						done();
					});
			});
	},
});

export default [createExperienceLogic];
